/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Value } from './Value.js';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value.js';

/**
 * 
 * @export
 * @interface CreateSuggestionRequest
 */
export interface CreateSuggestionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSuggestionRequest
     */
    fieldSlug?: string;
    /**
     * 
     * @type {Value}
     * @memberof CreateSuggestionRequest
     */
    value?: Value;
}

/**
 * Check if a given object implements the CreateSuggestionRequest interface.
 */
export function instanceOfCreateSuggestionRequest(value: object): boolean {
    return true;
}

export function CreateSuggestionRequestFromJSON(json: any): CreateSuggestionRequest {
    return CreateSuggestionRequestFromJSONTyped(json, false);
}

export function CreateSuggestionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSuggestionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldSlug': json['fieldSlug'] == null ? undefined : json['fieldSlug'],
        'value': json['value'] == null ? undefined : ValueFromJSON(json['value']),
    };
}

export function CreateSuggestionRequestToJSON(value?: CreateSuggestionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fieldSlug': value['fieldSlug'],
        'value': ValueToJSON(value['value']),
    };
}

